/**
 *
 * App.react.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCog,
  faTrashAlt,
  faPlus,
  faPlusCircle,
  faPencilAlt,
  faMinus,
  faDownload,
  faQuestionCircle,
  faCheck,
  faExclamationCircle,
  faEraser,
  faTimesCircle,
  faTimes,
  faImage,
  faInfo,
  faCloudUploadAlt,
  faExclamationTriangle,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCheckSquare,
  faEye,
  faEyeSlash,
  faArrowsAlt,
  faInfoCircle,
  faMinusCircle,
  faExpand,
  faCompress,
  faAngleLeft,
  faAngleRight,
  faSave,
  faUndoAlt,
} from '@fortawesome/free-solid-svg-icons';

import { ApplicationRouter } from 'routing/router';

library.add(
  faAngleLeft,
  faAngleRight,
  faCog,
  faTrashAlt,
  faPlus,
  faPlusCircle,
  faPencilAlt,
  faMinus,
  faDownload,
  faQuestionCircle,
  faCheck,
  faExclamationCircle,
  faTimesCircle,
  faTimes,
  faImage,
  faInfo,
  faCloudUploadAlt,
  faExclamationTriangle,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCheckSquare,
  faEye,
  faEyeSlash,
  faArrowsAlt,
  faInfoCircle,
  faMinusCircle,
  faEraser,
  faSave,
  faUndoAlt,
  faExpand,
  faCompress,
);

const App = () => <ApplicationRouter />;

export default App;
